export const getIconLabel = (isOpen) => (isOpen ? 'open' : 'close')
